import {
  CameraInfoResponse,
  CameraStartResponse,
  CameraStopResponse,
  RdConnectInstancePingResponse,
} from '@apiContract';
import axios from 'axios';

export interface RdConnectPingListParams {
  rdConnectInstanceId?: number;
}

interface RdConnectStartCapturingCreateParams {
  receiveSessionId: string;
  rdConnectInstanceId: number;
  index: number;
}

interface RdConnectStopCapturingCreateParams {
  rdConnectInstanceId: number;
}

interface RdConnectCameraInfoListParams {
  rdConnectInstanceId: number;
  index: number;
}

export const getRdConnectInstancePing = async (params: RdConnectPingListParams) => {
  return axios.get<RdConnectInstancePingResponse>(`RdConnectOperations/ping/${params.rdConnectInstanceId}`);
};

export const postStartCapturing = async ({
  rdConnectInstanceId,
  receiveSessionId,
  index,
}: RdConnectStartCapturingCreateParams) => {
  const url = `RdConnectOperations/start-capturing/${receiveSessionId}/${rdConnectInstanceId}/${index}`;

  return axios.post<CameraStartResponse>(url);
};

export const postStopCapturing = async ({ rdConnectInstanceId }: RdConnectStopCapturingCreateParams) => {
  return axios.post<CameraStopResponse>(`RdConnectOperations/stop-capturing/${rdConnectInstanceId}`);
};

export const getCameraInfo = async ({ rdConnectInstanceId, index }: RdConnectCameraInfoListParams) => {
  return axios.get<CameraInfoResponse>(`RdConnectOperations/camera-info/${rdConnectInstanceId}/${index}`);
};
